<template>
  <div>

    <VueSlickCarousel 
      :arrows="showArrows" 
      :dots="true"
      :infinite="false"
    >
      <div 
        v-for = "(media, index) in postContent" :key="index"
        class="carousel-item"
      >
  
        <Simple
          :postData="postData"
          :postContent="media"
          :model="model"
          :VideoElementHandler="VideoElementHandler"
        />
  
      </div>
    </VueSlickCarousel>

  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import Simple from "./Simple.vue";

export default {
  name: "PostCarousel",
  components: {
    Simple,
    VueSlickCarousel
  },
  props: {
    postData: {},
    postContent: {},
    model: {},
    VideoElementHandler: {},
  },
  computed: {
    showArrows() {
      return window.innerWidth > 768;
    },
  }
};
</script>

<style lang="scss">
@import "../../styles/variables.scss";
.slick-dots {
  position: unset;

  li {
    button:before {
        font-size: 12px !important;
        color: black !important;
    }

    &.slick-active button:before {
        color: var(--pallete_main_color) !important;
    }
  }
}

.slick-next:before, .slick-prev:before {
    color: black;
}

.slick-arrow {
  $SIZE: 30px;
  width: $SIZE;
  height: $SIZE;

  &::before {
    font-size: $SIZE;
  }

  $DISTANCE: -35px;

  &.slick-prev {
    left: $DISTANCE;
  }

  &.slick-next {
    right: $DISTANCE;
  }
}
</style>

<style lang="scss">
@import "../../styles/themes/chads";

body.chads {
  .slick-dots li {
    button {
      background-color: transparent;

      &:hover {
        background-color: transparent;
      }
    }
  }
}
</style>
